module.exports = __webpack_public_path__ + "img/sec3_button_choice.9c81fd78.jpg";